import { Pipe, PipeTransform, inject } from '@angular/core';
import { FeatureService } from '@feature-services/feature.service';
import { LoggerService } from '@util-services/logger.service';

@Pipe({
  name: 'calioFeature',
  standalone: true
})
export class CalioFeaturePipe implements PipeTransform {

  private featureService = inject(FeatureService);

  transform(value: string, ...args: any): boolean | number {
    const returnValue = this.featureService.hasFeature(value);
    args?.debug !== undefined && LoggerService.log('[calioFeature]', value, returnValue);
    return returnValue;
  }
}
